import { gql } from "@apollo/client"
import { SESSION_FRAGMENT } from "../../fragments"

const UPDATE_SESSION_MUTATION = gql `
  ${SESSION_FRAGMENT}

  mutation($input: UpdateSessionInput!) {
    updateSession(input: $input) {
      ...SessionFields
    }
  }
`

export { UPDATE_SESSION_MUTATION }
